import React from "react";

/**
 * Paper Plane Icon
 * Used for the send button in the notes section
 */
const PaperPlaneIcon = React.memo(() => (
  <svg 
    width="20" 
    height="20" 
    viewBox="0 0 20 20" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M18.3334 1.66675L9.16669 10.8334" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18.3334 1.66675L12.5 18.3334L9.16669 10.8334L1.66669 7.50008L18.3334 1.66675Z" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
));

export default PaperPlaneIcon; 